<script>
import { mapActions } from 'vuex';

export default {
  props: {
    id: {
      type: [String, Number],
    },
  },
  data() {
    return {
      toggled: false,
      error: null,
      pages: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      deleteFilter: 'filter/deleteFilter',
    }),
    reset() {
      this.$set(this, 'error', null);
      this.$set(this, 'pages', null);
      this.$set(this, 'loading', false);
    },
    del() {
      this.$set(this, 'loading', true);
      this.deleteFilter(this.id)
        .then(() => {
          this.$set(this, 'error', null);
          this.$set(this, 'pages', null);
          this.$set(this, 'toggled', false);
          this.$emit('deleted');
        })
        .catch((err) => {
          this.$set(this, 'error', err.response.data.identifier);
          if (err.response.data.identifier === 'relation_conflict') {
            this.$set(this, 'pages', err.response.data.data);
          } else {
            this.$set(this, 'pages', null);
          }
        })
        .finally(() => {
          this.$set(this, 'loading', false);
        });
    },
    close() {
      this.toggled = false;
    },
  },
  watch: {
    toggled(newValue) {
      if (newValue) {
        this.reset();
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    :persistent="loading"
    max-width="400px">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        color="grey"
        flat
        icon>
        <v-icon>delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="title">
        {{ $t('deleteFilter.heading') }}
        </span>
      </v-card-title>
      <v-divider/>
      <div v-if="!error">
        <v-card-text>
          {{ $t('deleteFilter.description') }}
        </v-card-text>
      </div>
      <div v-if="error">
        <div v-if="error === 'relation_conflict'">
          <v-card-text class="pb-3">
            {{ $t('deleteFilter.conflictText1') }}
          </v-card-text>
          <v-card-text class="pt-0 pb-3">
            <ul>
              <li
                v-for="(page, index) in pages"
                :key="index">
                <a
                  :href="page.url"
                  target="_blank">
                  {{ page.name }}
                </a>
              </li>
            </ul>
          </v-card-text>
          <v-card-text class="pt-0">
            {{ $t('deleteFilter.conflictText2') }}
          </v-card-text>
        </div>
        <v-card-text
          v-else
          class="red--text">
          {{ $t('deleteFilter.unexpectedText') }}
        </v-card-text>
      </div>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          flat
          :disabled="loading"
          @click="close">
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-btn
          flat
          color="red"
          :loading="loading"
          @click="del">
          {{ $t('buttons.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/TwDeleteFilter.vue